import { NavLink } from "react-router-dom";
import { Clock, ClipboardList, BookOpenText, Building2, Settings } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const workerTabs = [
    { to: "/heute", label: "Heute", icon: Clock, testid: "nav-heute" },
    { to: "/zeiten", label: "Zeiten", icon: ClipboardList, testid: "nav-zeiten" },
    { to: "/bautagebuch", label: "Bautagebuch", icon: BookOpenText, testid: "nav-bautagebuch" },
    { to: "/projekt", label: "Projekt", icon: Building2, testid: "nav-projekt" },
];

const adminTab = { to: "/admin", label: "Admin", icon: Settings, testid: "nav-admin" };

export default function BottomNav() {
    const { user } = useAuth();
    const tabs = user?.role === "admin" ? [...workerTabs, adminTab] : workerTabs;
    return (
        <nav
            data-testid="bottom-nav"
            className="fixed inset-x-0 bottom-0 z-40 border-t border-mes-border bg-white/95 backdrop-blur"
            style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
        >
            <div className="mx-auto flex max-w-2xl">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <NavLink
                            key={tab.to}
                            to={tab.to}
                            data-testid={tab.testid}
                            className={({ isActive }) =>
                                [
                                    "relative flex flex-1 flex-col items-center justify-center gap-1 py-2.5 min-h-[60px] text-[11px] font-medium",
                                    isActive ? "text-mes-brand" : "text-mes-muted hover:text-mes-ink",
                                ].join(" ")
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <span
                                        className={`absolute top-0 h-[2px] w-8 rounded-full transition-all ${
                                            isActive ? "bg-mes-brand opacity-100" : "opacity-0"
                                        }`}
                                    />
                                    <Icon className="h-[22px] w-[22px]" strokeWidth={isActive ? 2.4 : 1.8} />
                                    <span>{tab.label}</span>
                                </>
                            )}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
}
